import { copyright } from './common';

export default header => {
    console.log('header');
    const body = document.body;
    const mainNavigation = header.querySelector('.main-navigation');
    const menuMobileBtn = header.querySelector('.btn.menu-mobile');
    const clocks = header.querySelectorAll('.clock');
    const limit = 130;

    function handleScroll() {
        header.classList[window.scrollY >= limit ? 'add' : 'remove']('hide');
    }

    function updateTime(clock) {
        const date = new Date();
        const format = 'en-US';
        const options = {
            hour: '2-digit',
            minute: '2-digit',
        };

        switch (clock.dataset.city) {
            case 'newyork':
                options.timeZone = 'America/New_York';
                break;
            case 'paris':
                options.timeZone = 'Europe/Paris';
                break;
            default:
                break;
        }

        clock.querySelector('.clock-time').textContent = date.toLocaleTimeString(format, options);
    }

    clocks.forEach(clock => {
        updateTime(clock);
        setInterval(() => updateTime(clock), 1000);
    });

    if (window.innerWidth >= 992) {
        body.classList.add('desktop');
        window.addEventListener('scroll', handleScroll);
        handleScroll();
    } else {
        body.classList.add('mobile');
    }

    menuMobileBtn.addEventListener('click', event => {
        event.preventDefault();
        event.target.classList.toggle('open');
        body.classList.toggle('oh');
        mainNavigation.classList.toggle('show');
    });

    copyright();
};
